// extracted by mini-css-extract-plugin
module.exports = {"related-tours":"RelatedTours_related-tours__iG1cW"};